import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { Spinner } from './Spinner';

type Variant = 'primary' | 'secondary' | 'ghost' | 'danger';

const VARIANTS: Record<Variant, string> = {
  primary: 'bg-brand text-white hover:bg-brand-strong active:bg-brand-strong disabled:bg-ink-3',
  secondary: 'bg-surface text-ink border border-line-strong hover:bg-sunken active:bg-sunken',
  ghost: 'bg-transparent text-brand hover:bg-brand-soft active:bg-brand-soft',
  danger: 'bg-danger text-white hover:brightness-95',
};

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  loading?: boolean;
  icon?: ReactNode;
  block?: boolean;
}

export function Button({
  variant = 'primary',
  loading = false,
  icon,
  block = false,
  className = '',
  children,
  disabled,
  type = 'button',
  ...props
}: ButtonProps) {
  return (
    <button
      type={type}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      className={[
        'inline-flex min-h-12 items-center justify-center gap-2 rounded-control px-5 text-[15px] font-semibold',
        'transition-colors disabled:cursor-not-allowed disabled:opacity-70',
        VARIANTS[variant],
        block ? 'w-full' : '',
        className,
      ].join(' ')}
      {...props}
    >
      {loading ? <Spinner size={18} tone={variant === 'primary' || variant === 'danger' ? 'light' : 'dark'} /> : icon}
      {children}
    </button>
  );
}
